import api from './api';

/**
 * Projects API Service
 */
class ProjectsService {
  /**
   * Get all projects for authenticated user
   */
  async getProjects() {
    try {
      return await api.get('/projects');
    } catch (error) {
      console.error('Get projects error:', error);
      throw error;
    }
  }

  /**
   * Get a specific project by ID
   */
  async getProject(projectId) {
    try {
      return await api.get(`/projects/${projectId}`);
    } catch (error) {
      console.error('Get project error:', error);
      throw error;
    }
  }

  /**
   * Create a new project
   */
  async createProject(projectData) {
    try {
      return await api.post('/projects', projectData);
    } catch (error) {
      console.error('Create project error:', error);
      throw error;
    }
  }

  /**
   * Update an existing project
   */
  async updateProject(projectId, projectData) {
    try {
      return await api.put(`/projects/${projectId}`, projectData);
    } catch (error) {
      console.error('Update project error:', error);
      throw error;
    }
  }

  /**
   * Delete a project
   */
  async deleteProject(projectId) {
    try {
      return await api.delete(`/projects/${projectId}`);
    } catch (error) {
      console.error('Delete project error:', error);
      throw error;
    }
  }
}

const projectsService = new ProjectsService();
export default projectsService;

